import {get} from 'lodash';

import {ALERTS_STATE_IS_LOADING} from '/enum/alertsState.enum';

export default (state = {}, {type, stateValue}: any) => {
  return {
    ...state,
    allAlertsState: {
      ...get(state, 'allAlertsState', {}),
      [type]: {
        [ALERTS_STATE_IS_LOADING]: stateValue,
      },
    },
  };
};
